module.exports = __webpack_public_path__ + "static/media/support.44977d90.svg";